

import Vue from "vue";
import FastClick from "fastclick";
import Router from "vue-router";
import App from "./App";
import {routes} from "./router/index";


Vue.use(Router);
export const router = new Router({
mode: "history",
routes,
scrollBehavior(to, from, savedPosition) {  //记录滚动位置
if (savedPosition) {
sessionStorage.setItem('scrollY', savedPosition.y);
return savedPosition;
} else {
return {x: 0, y: 0}
}
}
});


import "vue-ydui/dist/ydui.base.css";
import {CellGroup, CellItem} from "vue-ydui/dist/lib.rem/cell";
import {Input} from "vue-ydui/dist/lib.rem/input";
import {Popup} from "vue-ydui/dist/lib.rem/popup";
import {Icons} from "vue-ydui/dist/lib.rem/icons";
import {Search} from "vue-ydui/dist/lib.rem/search";

Vue.component(Search.name, Search);
Vue.component(CellGroup.name, CellGroup);
Vue.component(CellItem.name, CellItem);
Vue.component(Input.name, Input);
Vue.component(Popup.name, Popup);
Vue.component(Icons.name, Icons);

import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'


Vue.use(AlertPlugin);
Vue.use(ToastPlugin);
Vue.use(ConfirmPlugin);


import base from "./utils/base";

Vue.use(base);

/** 修复fastclick在ios系统下，对某些输入元素类型需要长按才有反应的错误。
* @param {EventTarget|Element} targetElement
*/
FastClick.prototype.focus = function(targetElement) {
var length;

if (targetElement.setSelectionRange &&
targetElement.type.indexOf('date') !== 0 &&
targetElement.type !== 'time' &&
targetElement.type !== 'text' &&
targetElement.type !== 'password' &&
targetElement.type !== 'search' &&
targetElement.type !== 'month') {
length = targetElement.value.length;
targetElement.setSelectionRange(length, length);
} else {
targetElement.focus();
}
};

FastClick.attach(document.body);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount("#app-box");

export default router;


// WEBPACK FOOTER //
// ./src/main.js